export enum Language {
  FR = 'french',
  ENG = 'english',
}

export enum Audience {
  AGENCIES = 'agencies',
  ENTEPRISES = 'enterprises',
}
